import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const input: SxStyle = {
  '& .MuiInputBase-input::placeholder': {
    color: (p) => p.palette.grey[400],
    fontSize: (p) => p.typography.body2,
    fontWeight: 400,
  },
};

export const searchIcon: SxStyle = {
  color: (p) => p.palette.grey[500],
};
